import { render, staticRenderFns } from "./TextOverlayTopBar.vue?vue&type=template&id=27fcf014&scoped=true&"
import script from "./TextOverlayTopBar.vue?vue&type=script&lang=js&"
export * from "./TextOverlayTopBar.vue?vue&type=script&lang=js&"
import style0 from "./TextOverlayTopBar.vue?vue&type=style&index=0&id=27fcf014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fcf014",
  null
  
)

export default component.exports